module.exports = __webpack_public_path__ + "img/3D preview.7038ffbd.webp";